import { ApplicationType } from '../graphql/operations';

export function getInitalPaymentAmount(applicationType: ApplicationType) {
  return applicationType === ApplicationType.Core ? '50%' : '60%';
}
